import { render, staticRenderFns } from "./txt-primary.vue?vue&type=template&id=56ef1b92&scoped=true&"
import script from "./txt-primary.vue?vue&type=script&lang=js&"
export * from "./txt-primary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ef1b92",
  null
  
)

export default component.exports